module.exports = __webpack_public_path__ + "img/user_avatar_default.f63f2d9a.png";